module.exports = {
    projectId: "e8co8npp",
    dataset: "production",
};
